import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-dispose';

const createItem = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuConfigs`, payload);
};

const updateItem = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menuConfigs/${id}`, payload);
};

const removeItem = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/menuConfigs/${id}`, payload);
};

const findGlobalConfig = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/globalConfig`, payload);
};

const updateGlobalConfigs = (merchantId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/globalConfigs`, payload);
};

const listOfMenuGroups = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuGroups`, payload);
};

export default {
	createItem,
	updateItem,
	removeItem,
	findGlobalConfig,
	updateGlobalConfigs,
	listOfMenuGroups,
};
